import config from "../config"
const baseUrl = config.base_url + "work-code/indicator-execution-record/"
export default {
    page: {
        url: baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    getById: {
        url: baseUrl + "getExecutionRecordById/{id}",
        type: "get",
    },
    recent: {
        url: baseUrl + "recent",
        type: "get",
    },
    count: {
        url: baseUrl + "count",
        type: "get",
    },
    debug: {
        url: baseUrl + "debug",
        type: "post",
    },
    batchDelete: {
        url: baseUrl + "batch",
        type: "delete",
    }
}
